import { push } from "connected-react-router";
import * as authActions from "stores/actions/auth";
import { removePending } from "services/loginLinkService";
import { broadcastSessionReplaced } from "services/multiTabAuthSync";
import {
  CASHBOX_APPROVAL_PAGE_PATH,
  CASHBOX_APPROVAL_TOKEN_KEY,
  CASHBOX_APPROVAL_EMAILS_KEY
} from "constants/Paths";
import { WEB_ONLY_PARAM } from "routes/cashbox-approval/appHandoff";
import { LOGIN_LINK_PARAM } from "routes/cashbox-approval/constants";

export function completeLoginLink(dispatch, data) {
  dispatch(authActions.authLogin(data));
  removePending();
  sessionStorage.removeItem(CASHBOX_APPROVAL_TOKEN_KEY);
  sessionStorage.removeItem(CASHBOX_APPROVAL_EMAILS_KEY);
  broadcastSessionReplaced();

  dispatch(
    push(
      data.cashbox_approval_token
        ? `${CASHBOX_APPROVAL_PAGE_PATH}/${data.cashbox_approval_token}?${WEB_ONLY_PARAM}=1&${LOGIN_LINK_PARAM}=1`
        : "/login"
    )
  );
}
